import { Box, Button, Divider, Drawer, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material'
import { useState } from 'react';
import { useSelector } from 'react-redux'
import { Routes, Route, Outlet, Link, useLocation, HashRouter } from "react-router-dom";
import AccountTreeRoundedIcon from '@mui/icons-material/AccountTreeRounded';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import DialpadRoundedIcon from '@mui/icons-material/DialpadRounded';
import FaxRoundedIcon from '@mui/icons-material/FaxRounded';
import GraphicEqRoundedIcon from '@mui/icons-material/GraphicEqRounded';
import GroupRoundedIcon from '@mui/icons-material/GroupRounded';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import LibraryMusicRoundedIcon from '@mui/icons-material/LibraryMusicRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import PhoneRoundedIcon from '@mui/icons-material/PhoneRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import RuleRoundedIcon from '@mui/icons-material/RuleRounded';
import VoicemailRoundedIcon from '@mui/icons-material/VoicemailRounded';
import Companies from '../admin/Companies'
import Users from '../admin/Users'
import AudioFiles from './AudioFiles/AudioFiles'
import Extensions from './Extensions/Extensions'
import IVRMenus from './Menus/IVRMenus'
import CallRoutingRules from './Misc/CallRoutingRules'
import PhoneNumbers from './PhoneNumbers/PhoneNumbers'
import Recordings from './Recordings/Recordings'
import Holidays from './Misc/Holidays';
import BusinessHours from './Misc/BusinessHours';
import ModifyPhoneNumber from './PhoneNumbers/ModifyPhoneNumber';
import ModifyMenu from './Menus/ModifyMenu';
import ModifyExtension from './Extensions/ModifyExtension';
import Upload from './AudioFiles/Upload';
import ModifyAudioFile from './AudioFiles/ModifyAudioFile';
import TextToAudio from './AudioFiles/TextToAudio';
import EditRule from './Misc/EditRule';
import EditDtf from './Menus/EditDtf';
import AddMenu from './Menus/AddMenu';
import GlobalAudioFiles from './AudioFiles/GlobalAudioFiles';
import TelnyxWebRTCComponent from './Home/TelnyxWebRTCComponent';
import Billing from './Billing/Billing';
import InboundCallHistory from './CallHistory/InboundCallHistory';
import CallHistoryContainer from './CallHistory/CallHistoryContainer';
import MusicOnHold from './MusicOnHold/MusicOnHold';
import MusicOnHoldFiles from './MusicOnHold/MusicOnHoldFiles';
import FaxHistory from './Fax/FaxHistory';
import PhoneBook from './Misc/PhoneBook';
import HolidaysNew from './Misc/HolidaysNew';
import PhoneNumberList from './Misc/PhoneNumberList';
import HolidaySubscriptionManager from './Misc/HolidaySubscriptionManager';
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';
import { useAuth } from '../auth/AuthContext';

const holidayManagerEmail = 'store0000@uppals.com';

const LinkList = (props) => {
    
    const location = useLocation();
    const globalInfo = useSelector((state) => state.globalInfo)
    const { user } = useAuth();
    const canManageHolidaySubscriptions = (user.email || '').trim().toLowerCase() === holidayManagerEmail;

    const navItem = (label, to, icon, selected) => (
        <ListItemButton
            key={to}
            onClick={() => props.setOpen(false)}
            component={Link}
            to={to}
            selected={selected}
            sx={{
                mx: 1.25,
                mb: 0.35,
                minHeight: 44,
                borderRadius: 2,
                color: 'rgba(255,255,255,0.72)',
                '& .MuiListItemIcon-root': { color: 'rgba(255,255,255,0.5)' },
                '&:hover': { bgcolor: 'rgba(255,255,255,0.07)', color: 'white' },
                '&.Mui-selected': {
                    color: 'white',
                    bgcolor: 'rgba(112,214,224,0.16)',
                    '& .MuiListItemIcon-root': { color: '#70d6e0' },
                    '&:hover': { bgcolor: 'rgba(112,214,224,0.21)' }
                }
            }}
        >
            <ListItemIcon sx={{ minWidth: 38 }}>{icon}</ListItemIcon>
            <ListItemText primary={label} primaryTypographyProps={{ fontSize: 14, fontWeight: selected ? 750 : 550 }} />
        </ListItemButton>
    );

    const section = (label) => (
        <Typography sx={{ px: 2.75, pt: 2.5, pb: 0.8, color: 'rgba(255,255,255,0.34)', fontSize: 10.5, fontWeight: 800, letterSpacing: '0.12em' }}>
            {label}
        </Typography>
    );

    return (
        <Box sx={{ py: 1.25 }}>
            {section('CALL MANAGEMENT')}
            <List disablePadding>
                {navItem('My Phone Numbers', 'phonenumbers', <PhoneRoundedIcon fontSize="small" />,
                    location.pathname === '/phonenumbers' || location.pathname.includes('editphonenumber') || location.pathname.includes('businesshours') || location.pathname.includes('holidays') || location.pathname === '/')}
                {navItem('IVR Menus', 'ivr', <AccountTreeRoundedIcon fontSize="small" />,
                    location.pathname === '/ivr' || location.pathname.toLowerCase().includes('editmenu') || location.pathname.toLowerCase().includes('addmenu'))}
                {navItem('Audio Library', 'audiofiles', <LibraryMusicRoundedIcon fontSize="small" />,
                    location.pathname === '/audiofiles' || location.pathname.toLowerCase().includes('audio'))}
                {globalInfo.isAdministrator && navItem('Extensions', 'extensions', <DialpadRoundedIcon fontSize="small" />,
                    location.pathname === '/extensions' || location.pathname.toLowerCase().includes('extension'))}
                {navItem('Smart Rules', 'rules', <RuleRoundedIcon fontSize="small" />,
                    location.pathname === '/rules' || location.pathname.toLowerCase().includes('rule'))}
            </List>

            {section('ACTIVITY')}
            <List disablePadding>
                {navItem('Voicemail Recordings', 'voicemailrecordings', <VoicemailRoundedIcon fontSize="small" />, location.pathname === '/voicemailrecordings')}
                {globalInfo.currentCompanyId && globalInfo.hasCallRecordings && navItem('Call Recordings', 'callrecordings', <GraphicEqRoundedIcon fontSize="small" />, location.pathname === '/callrecordings')}
                {navItem('Call History', 'callhistory', <HistoryRoundedIcon fontSize="small" />, location.pathname === '/callhistory')}
                {globalInfo.currentCompanyId && globalInfo.isAdministrator && navItem('Fax History', 'faxhistory', <FaxRoundedIcon fontSize="small" />, location.pathname === '/faxhistory')}
            </List>

            {globalInfo.currentCompanyId && globalInfo.isAdministrator && <>
                {section('ADMINISTRATION')}
                <List disablePadding>
                    {navItem('Users', 'users', <GroupRoundedIcon fontSize="small" />, location.pathname === '/users')}
                    {navItem('Companies', 'companies', <BusinessRoundedIcon fontSize="small" />, location.pathname === '/companies')}
                    {navItem('Billing', 'billing', <ReceiptLongRoundedIcon fontSize="small" />, location.pathname === '/billing')}
                </List>
            </>}
            {canManageHolidaySubscriptions && <>
                {section('HOLIDAYS')}
                <List disablePadding>
                    {navItem('Manage Subscriptions', 'holiday-subscriptions', <EventAvailableRoundedIcon fontSize="small" />,
                        location.pathname === '/holiday-subscriptions')}
                </List>
            </>}
        </Box>
    )
}

const Layout = () => {
    const [open, setOpen] = useState(false);

    function toggle() {
        setOpen(!open)
    }
    const navigation = <LinkList setOpen={setOpen} open={open} />;

    return (
        <Box sx={{ display: 'flex', minHeight: { sm: 'calc(100vh - 72px)' } }}>
            <Box
                component="aside"
                sx={{
                    display: { xs: 'none', md: 'block' },
                    width: 258,
                    flexShrink: 0,
                    bgcolor: '#102c44',
                    borderRight: '1px solid rgba(255,255,255,0.05)'
                }}
            >
                <Box sx={{ position: 'sticky', top: 72, maxHeight: 'calc(100vh - 72px)', overflowY: 'auto' }}>
                    {navigation}
                </Box>
            </Box>

            <Drawer
                open={open}
                onClose={() => setOpen(false)}
                PaperProps={{ sx: { width: 278, bgcolor: '#102c44', color: 'white' } }}
            >
                <Box sx={{ px: 2.5, py: 2.25 }}>
                    <Typography fontWeight={800}>Portal navigation</Typography>
                    <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.5)' }}>Route My Call</Typography>
                </Box>
                <Divider sx={{ borderColor: 'rgba(255,255,255,0.08)' }} />
                {navigation}
            </Drawer>

            <Box component="main" sx={{ minWidth: 0, flex: 1 }}>
                <Box sx={{ display: { xs: 'flex', md: 'none' }, px: 2, py: 1.5, bgcolor: 'background.paper', borderBottom: '1px solid', borderColor: 'divider' }}>
                    <Button startIcon={<MenuRoundedIcon />} variant="outlined" size="small" onClick={toggle}>Menu</Button>
                </Box>
                <Box sx={{ p: { xs: 2, sm: 3, lg: 4 }, maxWidth: 1500, mx: 'auto' }}>
                    <Outlet />
                </Box>
            </Box>
        </Box>
    )
}

const Dashboard = () => {

    return (

        <HashRouter>
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<PhoneNumbers />} />
                    <Route path="/voicemailrecordings" element={<Recordings recordingType="VM"/>} />
                    <Route path="/callrecordings" element={<Recordings recordingType="CALL"/>} />
                    <Route path="/phonenumbers" element={<PhoneNumbers />} />
                    <Route path="/companies" element={<Companies />} />
                    <Route path="/ivr" element={<IVRMenus />} />
                    <Route path="/extensions" element={<Extensions />} />
                    <Route path="/rules" element={<CallRoutingRules />} />
                    <Route path="/music/:currentPhoneNumberId" element={<MusicOnHold />} />
                    <Route path="/music-on-hold" element={<MusicOnHoldFiles />} />
                    <Route path="/audiofiles" element={<AudioFiles />} />
                    <Route path="/globalaudiofiles" element={<GlobalAudioFiles />} />
                    <Route path="/companies" element={<Companies />} />
                    <Route path="/billing" element={<Billing />} />
                    <Route path="/callhistory" element={<CallHistoryContainer />} />
                    <Route path="/faxhistory" element={<FaxHistory />} />
                    <Route path="/callhistory2" element={<InboundCallHistory />} />
                    <Route path="/users" element={<Users />} />
                    <Route path="/businesshours/:currentPhoneNumberId" element={<BusinessHours />} />
                    <Route path="/phonebook/:currentPhoneNumberId" element={<PhoneBook />} />

                    <Route path="/ignorelist/:currentPhoneNumberId" element={<PhoneNumberList listType={"Ignore"} />} />
                    <Route path="/prioritylist/:currentPhoneNumberId" element={<PhoneNumberList listType={"Priority"} />} />
                    <Route path="/hanguplist/:currentPhoneNumberId" element={<PhoneNumberList listType={"Hangup"} />} />

                    <Route path="/adminholidays/:currentPhoneNumberId" element={<Holidays />} />
                    <Route path="/holidays/:currentPhoneNumberId" element={<HolidaysNew />} />
                    <Route path="/holiday-subscriptions" element={<HolidaySubscriptionManager />} />

                    <Route path="/webrtc/:currentPhoneNumberId" element={<TelnyxWebRTCComponent></TelnyxWebRTCComponent>} />
                    <Route path="/editPhoneNumber/:currentPhoneNumberId" element={<ModifyPhoneNumber />} />
                    <Route path="/addPhoneNumber" element={<ModifyPhoneNumber />} />
                    <Route path="/editMenu/:currentMenuId" element={<ModifyMenu />} />
                    <Route path="/addMenu" element={<AddMenu />} />
                    <Route path="/editExtension/:currentExtensionId" element={<ModifyExtension />} />
                    <Route path="/addextension" element={<ModifyExtension />} />


                    <Route path="/editAudioName/:currentAudioFileId" element={<ModifyAudioFile />} />

                    <Route path="/addAudioFile" element={<Upload />} />
                    <Route path="/editAudioFile/:currentAudioFileId" element={<Upload />} />

                    <Route path="/addTextToAudio" element={<TextToAudio />} />
                    <Route path="/editTextToAudio/:currentAudioFileId" element={<TextToAudio />} />

                    <Route path="/addRule" element={<EditRule />} />
                    <Route path="/editRule/:currentRuleId" element={<EditRule />} />

                    <Route path="/editDtf" element={<EditDtf />} />


                </Route>
            </Routes>
        </HashRouter>


    )
}

export default Dashboard
